import { css } from 'styled-components';
import { colors } from '../../atoms/colors/colors';
import { CheckboxTags } from './class-name-tags';
import { checkboxLightTheme } from './light-theme';
export const checkboxDarkTheme = {
    base: css `
    ${checkboxLightTheme.base}

    & .${CheckboxTags.root} {
      background-color: unset;

      &[data-state='checked'] {
        border-color: ${colors.warmgrey300};
      }

      &[disabled] {
        opacity: 0.6;

        &[data-state='checked'] {
          opacity: 0.6;
        }
      }
    }

    & .${CheckboxTags.indicator} {
      background-color: ${colors.warmgrey300};
      color: ${colors.warmgrey800};
    }

    & .${CheckboxTags.label} {
      color: ${colors.warmgrey300};
    }

    & .${CheckboxTags.labelDisabled} {
      color: ${colors.warmgrey500};
    }
  `,
};
//# sourceMappingURL=dark-theme.js.map